import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import EventRsvpsComponent from '../components/EventRsvpsComponent';

import { getEventData, getEventRsvps } from '../actions';

const LIST_KEY = 'eventRsvps';

const EventRsvpsContainer = ({ match }) => {
  const store = useSelector((store) => store);
  const dispatch = useDispatch();

  const { events, lists } = store;
  const listParams = lists?.[LIST_KEY] ?? {};

  const { id } = match.params;
  const items = events?.eventRsvps;

  const queryParams = {
    event_id: id,
    ...listParams,
  };

  const onLoad = () => {
    getEventData(dispatch, id);
  };

  const getItems = () => getEventRsvps(dispatch, queryParams);

  return (
    <EventRsvpsComponent
      onLoad={onLoad}
      getItems={getItems}
      listKey={LIST_KEY}
      listParams={listParams}
      items={items}
      queryParams={queryParams}
      eventId={id}
    />
  );
};

EventRsvpsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default EventRsvpsContainer;
